import React from 'react';
import { components } from 'react-select';
import propTypes from 'prop-types';

const DropdownIndicator = props => {
  const { menuIsOpen } = props.selectProps;
  return (
    <components.DropdownIndicator {...props}>
      <div className={menuIsOpen ? 'icon icon-arrow-up' : 'icon icon-arrow-down'} />
    </components.DropdownIndicator>
  );
};

DropdownIndicator.propTypes = {
  selectProps: propTypes.object.isRequired
};

export default DropdownIndicator;
